// The "Findtr" search app (installed as a sitewide app embed) finds the theme's own header
// search input(s) and stamps its own classes onto them for its autocomplete/suggestions UI —
// in doing so it also resets their placeholder text to a generic "Search", discarding whatever
// the theme sets. Findtr's own support confirmed this isn't something they can fix on their
// end and pointed to the theme instead, so this corrects it here: apply the intended placeholder
// immediately, then watch for Findtr (or anything else) changing it back and reapply.
(() => {
  const DESIRED_PLACEHOLDER = 'Search bottles, distilleries, regions ...';

  function isSearchInput(el) {
    return el instanceof HTMLInputElement && el.type === 'search' && el.name === 'q';
  }

  function applyPlaceholder(el) {
    if (el.placeholder !== DESIRED_PLACEHOLDER) {
      el.setAttribute('placeholder', DESIRED_PLACEHOLDER);
    }
  }

  function watch(el) {
    if (el.dataset.placeholderFixWatched) return;
    el.dataset.placeholderFixWatched = 'true';
    applyPlaceholder(el);
    new MutationObserver(() => applyPlaceholder(el)).observe(el, {
      attributes: true,
      attributeFilter: ['placeholder'],
    });
  }

  function scan() {
    document.querySelectorAll('input[type="search"][name="q"]').forEach(watch);
  }

  scan();

  // Findtr adds its own markup/inputs asynchronously after the theme's own DOMContentLoaded —
  // watch the whole document for newly-inserted search inputs rather than relying on a single
  // fixed-timing pass.
  new MutationObserver(scan).observe(document.body, { childList: true, subtree: true });
})();
